export default __webpack_public_path__ + "static/media/gel.02f2407b.jpg";